import React, { useEffect } from 'react';
import '../StylesComponents/LegalPages.css';

function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-content-wrapper">
        <header className="legal-header">
          <div className="legal-id-badge">PROTOCOL_DOCUMENT_TOS_v1.0</div>
          <h1 className="legal-title">Terms of Service</h1>
          <div className="legal-meta">
            <span>LAST_REVISION: FEB_2026</span>
            <span>STATUS: ACTIVE_LEGACY</span>
            <span>JURISDICTION: WESTERN_AUSTRALIA</span>
          </div>
        </header>

        <div className="legal-notice-box">
          <p>Important: Stockroom operates as a high-performance fashion aggregator. By accessing this platform, you acknowledge that transactions are executed on external retailer websites and fulfilled by independent third-party merchants.</p>
        </div>

        <section className="legal-section">
          <h2>01. Nature of Service</h2>
          <p className="legal-text">
            Stockroom (the "Platform") provides a centralised interface for discovering and purchasing fashion products from a variety of independent retailers (each a "Merchant"). 
            While we provide the technology to aggregate these products, the <strong>contract for sale is strictly between you and the Merchant</strong>.
          </p>
        </section>

        <section className="legal-section">
          <h2>02. Market Redirection Protocol</h2>
          <p className="legal-text">
            Stockroom facilitates discovery by redirecting users to the Merchant's official storefront. When you select a product:
          </p>
          <ul className="legal-list">
            <li>You will be redirected to the Merchant's secure website to complete the transaction.</li>
            <li>Shipping rates, taxes, and final payment terms are determined exclusively by the Merchant.</li>
            <li>Payments are processed securely by the Merchant's chosen payment gateway.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>03. Pricing and Data Integrity</h2>
          <p className="legal-text">
            We employ a proprietary <strong>Normaliser Engine</strong> to ensure product accuracy. However, as product data is ingested from external affiliate networks:
          </p>
          <ul className="legal-list">
            <li>We cannot guarantee 100% accuracy of stock levels or real-time pricing.</li>
            <li>In the event of a pricing conflict, the Merchant's final checkout price shall prevail.</li>
            <li>We are not responsible for orders, cancellations, or discrepancies occurring on third-party sites.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>04. Returns and Cancellations</h2>
          <p className="legal-text">
            As Stockroom does not physically hold inventory, <strong>all returns are subject to the specific return policy of the Merchant</strong> who fulfilled the item.
          </p>
          <ul className="legal-list">

            <li>Shipping costs for returns are determined by the originating Merchant.</li>
            <li>Refunds will be processed back to your original payment method only after the Merchant confirms receipt of the goods.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>05. Limitation of Liability</h2>
          <p className="legal-text">
            Under the Australian Consumer Law (ACL), certain guarantees are provided that cannot be excluded. However, to the maximum extent permitted by law, Stockroom is not liable for:
          </p>
          <ul className="legal-list">
            <li>Manufacturing defects or quality issues of products.</li>
            <li>Logistics delays caused by third-party carriers or Merchant nodes.</li>
            <li>Indirect losses resulting from platform downtime or API latency.</li>
          </ul>
        </section>

        <footer style={{ marginTop: '80px', padding: '40px 0', borderTop: '1px solid #111', color: '#444', fontSize: '10px', fontFamily: 'monospace' }}>
          END_OF_DOCUMENT // STOCKROOM_LEGAL_DEPT
        </footer>
      </div>
    </div>
  );
}

export default TermsOfService;
